module.exports = __webpack_public_path__ + "static/media/Peter-kleur.a7b263a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Peter-kleur.png
// module id = 4
// module chunks = 0